// extracted by mini-css-extract-plugin
export default {"googleLoginBtn":"GoogleLoginComponent_googleLoginBtn__zp5vw","googleLogo":"GoogleLoginComponent_googleLogo__YwHx-"};